import { render, staticRenderFns } from "./Placement_Group.vue?vue&type=template&id=3bab333a"
import script from "./Placement_Group.vue?vue&type=script&lang=js"
export * from "./Placement_Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports